export const setInStorage = (key: string, value: unknown, storage: 'local' | 'session' = 'local') => {
    try {
        if (storage === 'session') {
            sessionStorage.setItem(key, JSON.stringify(value));
        } else {
            localStorage.setItem(key, JSON.stringify(value));
        }
        return 'OK';
    } catch {
        return null;
    }
};

export const getFromStorage = (key: string, storage: 'local' | 'session' = 'local') => {
    try {
        let result;
        if (storage === 'session') {
            result = sessionStorage.getItem(key);
        } else {
            result = localStorage.getItem(key);
        }
        if (result) return JSON.parse(result);
        else return result;
    } catch {
        return null;
    }
};

export const removeFromStorage = (key: string, storage: 'local' | 'session' = 'local') => {
    try {
        if (storage === 'session') {
            sessionStorage.removeItem(key);
        } else {
            localStorage.removeItem(key);
        }
        return 'OK';
    } catch {
        return null;
    }
};

export const clearStorage = () => {
    try {
        localStorage.clear();
        return 'OK';
    } catch {
        return null;
    }
};

export const setInStorageWithExpiry = (key: string, value: unknown, ttl: number) => {
    try {
        localStorage.setItem(
            key,
            JSON.stringify({
                value: value,
                expiry: Date.now() + ttl,
            }),
        );
        return 'OK';
    } catch {
        return null;
    }
};

export const getFromStorageWithExpiry = (key: string) => {
    try {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    } catch {
        return null;
    }
};
